module.exports = __webpack_public_path__ + "static/media/spara_text.97c818bc.png";